/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessCodeModel } from '../../models/access-code-model';
import { ProfileValidateModel } from '../../models/profile-validate-model';

export interface SessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost$Params {
  systemIdentifierId: string;
  accessCode: string;
      body?: ProfileValidateModel
}

export function sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost(http: HttpClient, rootUrl: string, params: SessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<AccessCodeModel>> {
  const rb = new RequestBuilder(rootUrl, sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost.PATH, 'post');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
    rb.path('accessCode', params.accessCode, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<AccessCodeModel>;
    })
  );
}

sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost.PATH = '/Session/AccessCodeIdentifierAllowed/{systemIdentifierId}/{accessCode}';
